import { lensProp, omit, over, path, pathOr, pick } from 'ramda';

import { types as sdkTypes } from '../../util/sdkLoader';
import { parse } from '../../util/urlHelpers';
import { fetchMonthlyTimeSlots, fetchReviews, showListing } from '../../ducks/listing.duck';
import { getUserToken } from '../../ducks/user.duck';
import { getAnswerListingChatBot } from '../../util/api';

const { UUID } = sdkTypes;

export const LISTING_CHATBOT_MESSAGES_RESET =
  'LISTING_CHATBOT_MESSAGES_RESET';
export const SEND_LISTING_CHATBOT_MESSAGE_REQUESTED =
  'SEND_LISTING_CHATBOT_MESSAGE_REQUESTED';
export const SEND_LISTING_CHATBOT_MESSAGE_SUCCESS =
  'SEND_LISTING_CHATBOT_MESSAGE_SUCCESS';
export const SEND_LISTING_CHATBOT_MESSAGE_ERROR =
  'SEND_LISTING_CHATBOT_MESSAGE_ERROR';

// ================ Reducer ================ //

const initialState = {
  isLoading: false,
  error: null,
  listingId: null,
  result: null,
  conversation: [],
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload = {} } = action;
  const { error, message, listingId } = payload || {};
  switch (type) {
    case LISTING_CHATBOT_MESSAGES_RESET:
      return listingId === state.listingId
        ? state
        : {
          ...state,
          ...initialState,
          listingId,
        };
    case SEND_LISTING_CHATBOT_MESSAGE_REQUESTED:
      return {
        ...state,
        isLoading: true,
        error: null,
        result: null,
        conversation: [...state.conversation, message],
      };
    case SEND_LISTING_CHATBOT_MESSAGE_ERROR:
      return {
        ...state,
        isLoading: false,
        error,
        result: 'failure',
      };
    case SEND_LISTING_CHATBOT_MESSAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        result: 'success',
        conversation: [...state.conversation, message],
      };
    default:
      return state;
  }
}

export const resetListingChatBotMessages = (listingId) => ({
  type: LISTING_CHATBOT_MESSAGES_RESET,
  payload: {
    listingId,
  },
});

export const sendNewListingChatBotMessageRequested = (message) => ({
  type: SEND_LISTING_CHATBOT_MESSAGE_REQUESTED,
  payload: {
    message,
  },
});

const sendMessageSuccess = (message) => ({
  type: SEND_LISTING_CHATBOT_MESSAGE_SUCCESS,
  payload: {
    message,
  },
});
const sendMessageError = e => ({
  type: SEND_LISTING_CHATBOT_MESSAGE_ERROR,
  error: true,
  payload: e,
});

const trackSendQuestionChatBotBrevo = (email, listingId, listingTitle) => {
  try {
    if (!email || !listingId || !listingTitle) return;

    window.sendinblue.track(
      'ChatBot_Message_Sent',
      {
        email,
        LISTING_ID: listingId,
        LISTING_TITLE: listingTitle,
      },
      {
        email,
        LISTING_ID: listingId,
        LISTING_TITLE: listingTitle,
      },
    );
  } catch (e) {
    console.log('trackSendQuestionChatBotBrevo err', e);
  }
};

export const sendNewListingChatBotMessage = (message, currentUser, listingDataRaw, listingId) => (dispatch, getState, sdk) => {
  dispatch(sendNewListingChatBotMessageRequested({
    id: `message-${new Date().getTime()}`,
    type: 'message',
    attributes: {
      createdAt: new Date(),
      content: message,
    },
    sender: currentUser,
  }));
  // console.log('sendNewListingChatBotMessage', message, currentUser?.id?.uuid, listingId, listingDataRaw);
  try {
    const token = getUserToken();
    const listingData = over(lensProp('publicData'), omit([
      'fullDayPrice',
      'priceMorningSlot',
      'priceAfternoonSlot',
      'priceEveningSlot',
      'oldMinAmountPerHour',
      'pricePerExtraGuest',
      'pricingExtraHours',
      'pricingBaseNumberOfPeople',
      'reviewsInfo',
    ]), pick([
      'title',
      'publicData',
      'description',
    ], listingDataRaw));
    console.log('sendNewListingChatBotMessage listingData', listingData);
    return getAnswerListingChatBot({ messageText: message, listingId, customerId: currentUser?.id?.uuid, listingData }, token).then(response => {
      console.log('answer', response);
      const message = {
        id: `message-${new Date().getTime()}`,
        type: 'message',
        attributes: {
          createdAt: new Date(),
          content: path(['answer'], response),
        },
        sender: null,
      };

      dispatch(sendMessageSuccess(message));
      const userEmail = path(['user', 'currentUser', 'attributes', 'email'], getState());
      trackSendQuestionChatBotBrevo(userEmail, listingId, listingData?.title)
    }).catch(e => {
      dispatch(sendMessageError(e));
    });

  } catch (error) {
    dispatch(sendMessageError(error));
  }
};

export const loadData = (params, search) => dispatch => {
  const listingId = new UUID(params.id);

  return Promise.all([dispatch(showListing(listingId)), dispatch(fetchReviews(listingId))]).then(
    responses => {
      if (responses[0] && responses[0].data && responses[0].data.data) {
        const listing = responses[0].data.data;
        const parsedSearch = parse(search);
        const bookingDate = path(['bookingDate'], parsedSearch);

        // Fetch timeSlots.
        // This can happen parallel to loadData.
        // We are not interested to return them from loadData call.
        fetchMonthlyTimeSlots(dispatch, listing, bookingDate);
      }
      return responses;
    },
  );
};

